export default "__VITE_ASSET__SH5L7kIs__"